import { render, staticRenderFns } from "./FilteredProjectTable.vue?vue&type=template&id=74b5eaf6&"
import script from "./FilteredProjectTable.vue?vue&type=script&lang=ts&"
export * from "./FilteredProjectTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports